<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Admin List">
       
        <br />
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">Version</b-th>
              <b-th class="text-center" style="width: 50%" v-if="$store.getters.userDetails.includes('CAN_STATUS_SW_VER')">Force Update</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(version, index) in versions" :key="index">
              <b-td class="text-center">
                {{ version.version }}
              </b-td>
               <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_STATUS_SW_VER')">
                <b-button
                  :class="{ 'btn-danger': !version.force_update }"
                  size="sm"
                  :variant="buttonVariant"
                  @click="toggleStatus(version.id, index, version.force_update)"
                >
                  {{ version.force_update ? "Yes" : "No" }}
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      
      <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
        
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader: false,
      versions: [],
      buttonVariant: "success",
    };
  },
  mounted() {
    this.getVersions();
  },
  methods: {
   async toggleStatus(id, index, force_update) {
      await axios
        .get(`${this.$store.getters.baseUrl}/version/update/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getVersions();
            this.versions[index].force_update = force_update == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message} successfully`,
              icon: status ? "error" : "success",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getVersions() {
     this.loader = true
      await axios
        .get(`${this.$store.getters.baseUrl}/versions`, {
           headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then(async(response) => {
          console.log(response);
          this.versions = await response.data.setting;
           this.loader = false
        })
        .catch((error) => {
          console.log(error);
           this.loader = false
          this.$swal("Error", error.response.data.message, error);
        });
    },
  },
};
</script>
